import React, { type JSX } from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import ParagraphItem from "./YamlParagraphItem";
import type { Paragraph } from "./yamlPreviewTypes";

/** The list of document paragraphs, with expand/collapse controls. */
export default function YamlParagraphsPanel({
  paragraphs,
  expandedParagraphs,
  onToggleParagraph,
  onToggleAll,
}: {
  paragraphs: Paragraph[];
  expandedParagraphs: Set<number>;
  onToggleParagraph: (index: number) => void;
  onToggleAll: (expand: boolean) => void;
}): JSX.Element {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="p-4 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <DocumentTextIcon className="h-5 w-5 text-blue-600" />
          <h2 className="text-base font-semibold text-gray-900">Document Paragraphs</h2>
          <span className="text-xs text-gray-500">({paragraphs.length} paragraphs)</span>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onToggleAll(true)}
            className="text-xs text-blue-600 hover:text-blue-700 font-medium"
          >
            Expand All
          </button>
          <span className="text-gray-300">|</span>
          <button
            onClick={() => onToggleAll(false)}
            className="text-xs text-blue-600 hover:text-blue-700 font-medium"
          >
            Collapse All
          </button>
        </div>
      </div>

      <div className="divide-y divide-gray-100">
        {paragraphs.map((paragraph, index) => (
          <ParagraphItem
            key={index}
            paragraph={paragraph}
            index={index}
            isExpanded={expandedParagraphs.has(index)}
            onToggle={() => onToggleParagraph(index)}
          />
        ))}
      </div>
    </div>
  );
}
